module.exports = __webpack_public_path__ + "img/stu-answer-ready-bg_new.c985dee1.png";